import { render, staticRenderFns } from "./cardInnerList.vue?vue&type=template&id=0bbbf8a0&scoped=true"
import script from "./cardInnerList.vue?vue&type=script&lang=ts"
export * from "./cardInnerList.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./cardInnerList.vue?vue&type=style&index=0&id=0bbbf8a0&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "0bbbf8a0",
  "16743a39"
  
)

export default component.exports